import React from 'react';

import './StepHeader.scss';
export function StepHeader({ children }) {
  return <span className="add-ledger-step-header">{children}</span>;
}
